import type { CSSProperties } from 'react';
import {
  resolveSectionColor,
  sectionSurfaceCssVars,
  sectionSurfaceTokens,
  withAlpha,
  type SectionSurfaceTokens,
} from './sectionColors';

export {
  resolveSectionColor,
  sectionSurfaceCssVars,
  sectionSurfaceTokens,
  withAlpha,
};
export type { SectionSurfaceTokens };

/** Inline style object for a category/section bordered surface. */
export function sectionSurfaceStyle(
  categoryOrHex: string,
  options?: { selected?: boolean; interactive?: boolean }
): CSSProperties {
  const hex = categoryOrHex.startsWith('#')
    ? categoryOrHex
    : resolveSectionColor(categoryOrHex);
  const t = sectionSurfaceTokens(hex);
  const vars = sectionSurfaceCssVars(hex) as CSSProperties;
  return {
    ...vars,
    borderColor: options?.selected ? t.borderActive : t.border,
    backgroundColor: options?.selected ? t.tintHover : t.tint,
  };
}

/** Class list for section surfaces (pair with sectionSurfaceStyle / CSS vars). */
export function sectionSurfaceClassName(options?: {
  interactive?: boolean;
  selected?: boolean;
  className?: string;
}): string {
  const parts = ['section-surface'];
  if (options?.interactive) parts.push('section-surface-interactive');
  if (options?.selected) parts.push('section-surface-selected');
  if (options?.className) parts.push(options.className);
  return parts.join(' ');
}
